document.addEventListener('DOMContentLoaded', () => {

    // ===============================
    // MOBILE NAVIGATION DRAWER
    // ===============================

    const mobileNavigationDrawer = document.querySelector('#mobile-navigation-drawer summary');

    mobileNavigationDrawer.setAttribute('aria-disabled', 'false');

    mobileNavigationDrawer?.addEventListener('click', () => {
        document.body.classList.toggle('mobile-navigation-drawer-open');
    });

    const backButtons = document.querySelectorAll('.back-button');

    backButtons.forEach(button => {
        button.addEventListener('click', () => {
            button.closest('[open]')?.removeAttribute('open');
        });
    });

    const megaMenuDesktopItems = document.querySelectorAll('.mega-menu-desktop__dropdown');

    megaMenuDesktopItems?.forEach(item => {
        item.addEventListener('toggle', () => {
            const anyOpen = document.querySelector('.mega-menu-desktop__dropdown[open]');

            document.body.classList.toggle('mega-menu-desktop-open', !!anyOpen);
        });
    });


    // ===============================
    // SCROLL NONE
    // ===============================

    document.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
            document.body.removeAttribute('scroll-none');
        } else {
            document.body.setAttribute('scroll-none', '');
        }
    });

    document.addEventListener('click', (e) => {
        if (!document.body.classList.contains('mega-menu-desktop-open')) return;

        const clickedInsideHeader = e.target.closest('header'); // usa tu selector real

        if (!clickedInsideHeader) {
            document
                .querySelectorAll('.mega-menu-desktop__dropdown[open]')
                .forEach(d => d.removeAttribute('open'));

            document.body.classList.remove('mega-menu-desktop-open');
        }
    });


    const allDetailsDesktop = document.querySelectorAll('.mega-menu-desktop__dropdown');

    allDetailsDesktop.forEach(detail => {
        detail.classList.remove('not-events');
        detail.addEventListener('toggle', () => {
            if (detail.open) {
                allDetailsDesktop.forEach(other => {
                    if (other !== detail) {
                        other.removeAttribute('open');
                    }
                });
            }
        });
    });

    const allDetailsMobile = document.querySelectorAll('.mega-menu__item-level-2');

    allDetailsMobile.forEach(detail => {
        detail.addEventListener('toggle', () => {
            if (detail.open) {
                const parent = detail.parentElement;

                parent.querySelectorAll('.mega-menu__item-level-2').forEach(other => {
                    if (other !== detail) {
                        other.removeAttribute('open');
                    }
                });
            }
        });
    });
});

